import { yupResolver } from '@hookform/resolvers/yup'
import { UilArrowLeft } from '@iconscout/react-unicons'
import { Button, Flex, Textarea, Typography } from 'components'
import { useAIContext } from 'containers/AI/context/AIProvider'
import React from 'react'
import { Controller, useForm } from 'react-hook-form'
import { useSelector } from 'react-redux'
import { useSendFeedbackMutation } from 'services/ai'
import { selectClientId, selectCurrentUser } from 'services/slices/auth'
import styled from 'styled-components'
import { useTranslation } from 'utils/useTranslation'
import * as yup from 'yup'

export type FeedbackProps = {}

const schema = yup.object({
  feedback: yup.string().required(),
})

type FormInputs = {
  feedback: string
}

export const Feedback: React.FC<FeedbackProps> = () => {
  const { t } = useTranslation('pages.ai.starters.feedback.modal')
  const { setPage } = useAIContext()
  const clientId = useSelector(selectClientId)
  const user = useSelector(selectCurrentUser)

  const { control, handleSubmit } = useForm<FormInputs>({
    resolver: yupResolver(schema),
  })

  const [sendFeedback, { isLoading, isSuccess, isError }] = useSendFeedbackMutation()

  const onSubmit = ({ feedback }: FormInputs) => {
    sendFeedback({
      client_name: user?.clients.find(({ value }) => value.toString() === clientId?.toString())
        ?.label,
      username: user?.username,
      message: feedback,
    }).unwrap()
  }

  return (
    <FeedbackForm onSubmit={handleSubmit(onSubmit)}>
      {isSuccess && (
        <Typography align="center" color="green600">
          {t('success')}
        </Typography>
      )}
      {isError && (
        <Typography align="center" color="red600">
          {t('error')}
        </Typography>
      )}
      <Typography fontSize="text_lg" fontWeight="medium">
        {t('title')}
      </Typography>
      <Typography color="grey700">{t('description')}</Typography>
      <Controller
        render={({ field, fieldState: { error } }) => (
          <Textarea
            {...field}
            error={!!error}
            style={{
              resize: 'none',
            }}
            rows={7}
            placeholder={t('placeholder')}
          />
        )}
        name="feedback"
        control={control}
      />
      <Flex gap={1}>
        <Button
          loading={isLoading}
          type="button"
          onClick={() => setPage(undefined)}
          iconLeft={UilArrowLeft}
          variant="text"
          color="secondary"
        >
          {t('go_back')}
        </Button>
        <Button type="submit" loading={isLoading}>
          {t('send_feedback')}
        </Button>
      </Flex>
    </FeedbackForm>
  )
}

const FeedbackForm = styled.form`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 1rem;
  width: 400px;
  margin: 0 auto;
`
